<div class="premium-dialog-ui">
    <div class="form-row align-item-center">
        <div class="col-auto">
            <img
                src="/assets/images/premium-invites.svg"
                class="premium-icon"
                alt="Premium invite" />
        </div>
        <div class="col-10 m-title col-md"
            *ngIf="addOnId == 1 && !isFromCategory">
            Craft Invitation with personalized envelope
        </div>
        <div class="col-10 m-title col-md"
            *ngIf="addOnId == 2 && !isFromCategory">
            Create Video By Professional
        </div>
        <div class="col-10 m-title col-md" *ngIf="isFromCategory">
            Video Preview
        </div>
        <div class="col-md-auto d-none d-md-flex mr-4" *ngIf="isFromCategory">
            <div class="form-row">
                <div class="col-md-auto col" *ngIf="!isFromPayment">
                    <button class="btn btn-main"
                        (click)="startCustomizing()">
                        Customize Now
                    </button>
                    
                </div>
            </div>
        </div>
        <div class="close-button" (click)="close()">
            <span class="material-icons"> close </span>
        </div>
    </div>
    <div *ngIf="!isFromCategory">
        <div class="row mt-4" *ngIf="addOnId == 1">
            <div class="col-md-auto col-12">
                <div class="mx-auto" style="width: fit-content">
                    <div class="mobile_header ng-tns-c3588437439-0"></div>
                    <div class="mobile_body">
                        <iframe [src]="videoPath" frameborder="0"></iframe>
                    </div>
                    <div class="mobile_footer ng-tns-c3588437439-0"></div>
                </div>
            </div>
            <div class="col-md-6" *ngIf="!isFromCategory">
                <div
                    class="premium-preview-modal__details premium"
                    *ngIf="!isFromCategory">
                    <div class="premium-preview-modal__detail-section">
                        <p class="font-weight-bold">
                            Explore our exceptional feature: RSVP directly on
                            the payment
                            page. Simply copy the link from our download page
                            post-payment and
                            effortlessly share it via WhatsApp.
                        </p>
                        <div
                            class="premium-preview-modal__detail-item p-model-content mt-4">
                            <div class="form-row align-item-center">
                                <div class="col-auto">
                                    <img
                                        src="/assets/images/premium-invites.svg"
                                        class="premium-icon-small"
                                        alt="Premium invite" />
                                </div>
                                <div class="col">
                                    <p class="pera">
                                        Elevate your invitation with a
                                        captivating envelope
                                        animation in your video, offering your
                                        guests a premium
                                        experience.
                                    </p>
                                </div>
                            </div>
                            <div class="form-row align-item-center">
                                <div class="col-auto">
                                    <img
                                        src="/assets/images/premium-invites.svg"
                                        class="premium-icon-small"
                                        alt="Premium invite" />
                                </div>
                                <div class="col">
                                    <p class="pera">
                                        Receive a shareable invitation link
                                        directly from our
                                        download page.
                                    </p>
                                </div>
                            </div>
                            <div class="form-row align-item-center">
                                <div class="col-auto">
                                    <img
                                        src="/assets/images/premium-invites.svg"
                                        class="premium-icon-small"
                                        alt="Premium invite" />
                                </div>
                                <div class="col">
                                    <p class="pera">
                                        Share the link effortlessly across
                                        WhatsApp, email, and
                                        various social media platforms.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="floating-buttons d-flex d-md-none">
                            <button class="btn btn-secondary"
                                (click)="close()">Close</button>
                            <button class="btn btn-main"
                                (click)="startCustomizing()">
                                Start Customizing
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="isFromCategory">
        <div class="row mt-2 justify-content-center" *ngIf="addOnId == 1">
            <div class="col-md-auto col-12">
                <div class="mx-auto" style="width: fit-content">
                    <div class="mobile_header ng-tns-c3588437439-0"></div>
                    <div class="mobile_body">
                        <iframe [src]="videoPath" frameborder="0"></iframe>
                    </div>
                    <div class="mobile_footer ng-tns-c3588437439-0"></div>
                </div>
            </div>
            <div class="col-md-12">
                <div class="premium-preview-modal__details premium">
                    <div class="premium-preview-modal__detail-section">
                        <div class="floating-buttons d-flex d-md-none">
                            <button
                                class="btn btn-secondary"
                                (click)="close()"
                                *ngIf="isShowButton">
                                Close
                            </button>
                            <button
                                class="btn btn-main"
                                (click)="startCustomizing()"
                                *ngIf="isShowButton">
                                Start Customizing
                            </button>
                        </div>
                        <div
                            class="form-row d-none justify-content-center">
                            <div class="col-md-auto col-auto">
                                <button class="btn btn-secondary mt-3"
                                    (click)="close()">
                                    Close
                                </button>
                            </div>
                            <div class="col-md-auto col" *ngIf="!isFromPayment">
                                <button class="btn btn-main mt-3"
                                    (click)="startCustomizing()">
                                    Start Customizing
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="addOnId == 2">
        <div class="video-by-us">
            <section>
                <h5>What to Expect:</h5>
                <p>
                    <strong>A Personal Touch:</strong> Expect a personalized
                    experience as
                    our skilled professionals reach out to you. We believe in
                    understanding your preferences and capturing the essence of
                    your event
                    to create a truly unique video invitation.
                </p>
                <p>
                    <strong>Scheduling the Connection:</strong> Our team will
                    coordinate
                    with you to schedule a convenient time for the connection.
                    We value
                    your time and aim to make the process as smooth and
                    efficient as
                    possible.
                </p>

                <p>
                    <strong>In-depth Discussion:</strong> During the connection,
                    our
                    professionals will engage in an in-depth discussion to delve
                    into the
                    specifics of your event. From thematic preferences to
                    intricate
                    details, we want to ensure that your video invitation
                    reflects your
                    style and resonates with your guests.
                </p>

                <p>
                    <strong>Clarifying Queries:</strong> Feel free to ask any
                    questions or
                    seek clarification during the discussion. Our team is here
                    to address
                    your queries and provide guidance, ensuring that you have
                    full
                    confidence in the invitation creation process.
                </p>

                <p>
                    <strong>Collaborative Creation:</strong> Consider this
                    connection as a
                    collaborative effort. Share your ideas, preferences, and any
                    special
                    elements you envision in your invitation. Our professionals
                    are here
                    to turn your vision into a captivating reality.
                </p>
            </section>

            <section>
                <h5>Why Choose Personalized Connections:</h5>
                <p>
                    <strong>Tailored to You:</strong> Personal connections allow
                    us to
                    tailor the invitation creation process specifically to your
                    needs,
                    ensuring a bespoke and meaningful end result.
                </p>

                <p>
                    <strong>Efficient and Effective:</strong> By connecting
                    directly, we
                    streamline the information-gathering process, making it
                    efficient and
                    effective. This ensures a quicker turnaround time for your
                    completed
                    video invitation.
                </p>

                <p>
                    <strong>Exceptional Quality:</strong> Our commitment to
                    excellence
                    extends to every aspect of the invitation creation process.
                    Personalized connections contribute to the exceptional
                    quality and
                    attention to detail that define our services.
                </p>
            </section>
        </div>
        <div class="floating-buttons d-flex d-md-none">
            <button class="btn btn-secondary" (click)="close()">Close</button>
        </div>
        <div class="form-row d-none d-md-flex">
            <div class="col-md-auto col-auto">
                <button class="btn btn-secondary mt-3"
                    (click)="close()">Close</button>
            </div>
        </div>
    </div>
    <div *ngIf="addOnId == 8">
        <div
            [class]="displayType == 2 ? 'envelope-pdf-verticle' : 'envelope-pdf'"
            *ngIf="invitationType == 2">
            <div class="envelope-header">Preview Demo Card</div>
            <div class="pdf-container">
                <pdf-viewer
                    [src]="documentPath"
                    [rotation]="0"
                    [original-size]="false"
                    [show-all]="true"
                    [fit-to-page]="false"
                    [zoom]="1"
                    [zoom-scale]="'page-width'"
                    [stick-to-page]="false"
                    [render-text]="true"
                    [external-link-target]="'blank'"
                    [autoresize]="true"
                    [show-borders]="false"
                    style="width: 100%; height: 100vh"></pdf-viewer>
            </div>
        </div>
    </div>
</div>
